import { Close } from '@mui/icons-material';
import { Box, IconButton, useMediaQuery } from '@mui/material';
import { ReactNode } from 'react';

import { backgroundV2 } from '@/images';

export const ModalContentContainer = ({
  children,
  onModalClose,
  stretch = false,
  leftColumnContents,
  leftColumnWidth = 320,
}: {
  children?: ReactNode;
  onModalClose?: () => void;
  stretch?: boolean;
  leftColumnContents?: ReactNode;
  leftColumnWidth?: number;
}) => {
  const isMdDown = useMediaQuery(theme => theme.breakpoints.down('md'));
  const showLeftColumn = !!leftColumnContents && !isMdDown;

  return (
    <Box
      sx={[
        {
          boxShadow: '0px 14px 19px 0px rgba(0, 0, 0, 0.25)',
          borderRadius: 4,
          backgroundColor: 'surface.background',
          position: 'relative',
          p: { xs: 3, md: 6 },
          minWidth: { xs: 'auto', md: 460 },
          width: stretch
            ? '100%'
            : 460 + (showLeftColumn ? leftColumnWidth : 0),
          maxWidth: '100%',
          height: stretch ? '100%' : 'auto',
          wordBreak: 'break-word',
        },
      ]}>
      {onModalClose && (
        <IconButton
          aria-label="Close modal"
          onClick={onModalClose}
          sx={{
            position: 'absolute',
            top: { xs: 4, md: 12 },
            right: { xs: 4, md: 12 },
          }}>
          <Close
            sx={{
              fontSize: 28,
              color: 'text.main',
            }}
          />
        </IconButton>
      )}
      {showLeftColumn && (
        <Box
          sx={{
            display: { xs: 'none', md: 'flex' },
            p: { xs: 3, md: 6 },
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            width: leftColumnWidth,
            background: `url(${backgroundV2}) center`,
          }}>
          {leftColumnContents}
        </Box>
      )}
      <Box
        sx={{
          height: '100%',
          width: '100%',
          pl: {
            xs: 0,
            md: showLeftColumn ? `${leftColumnWidth}px` : 0,
          },
        }}>
        {children}
      </Box>
    </Box>
  );
};
